import type { QuestionnaireTemplate } from '@common/types';

import { PROPERTIES } from './group-scope.seed';

function usage(count: number, driftedEvery: number, detachedIndex = -1) {
  return PROPERTIES.slice(0, count).map((property, index) => ({
    accountId: property.id,
    accountName: property.name,
    hasDrifted: index % driftedEvery === 0 && index !== detachedIndex,
    detached: index === detachedIndex,
  }));
}

export const QUESTIONNAIRE_TEMPLATES_SEED: ReadonlyArray<QuestionnaireTemplate> = [
  {
    id: 'tpl-post-stay',
    organizationId: 'sun-intl',
    name: 'Group Post-Stay 2026',
    type: 'post-stay',
    status: 'published',
    questionCount: 14,
    version: 4,
    lastPublishedIso: '2026-06-15T09:00:00.000Z',
    usage: usage(18, 6, 11),
  },
  {
    id: 'tpl-pre-stay',
    organizationId: 'sun-intl',
    name: 'Group Pre-Arrival',
    type: 'pre-stay',
    status: 'published',
    questionCount: 6,
    version: 2,
    lastPublishedIso: '2026-03-02T09:00:00.000Z',
    usage: usage(12, 9),
  },
  {
    id: 'tpl-conference',
    organizationId: 'sun-intl',
    name: 'Conference & Events',
    type: 'custom',
    status: 'published',
    questionCount: 11,
    version: 1,
    lastPublishedIso: '2026-01-20T09:00:00.000Z',
    usage: usage(7, 4),
  },
  {
    id: 'tpl-cancellation',
    organizationId: 'sun-intl',
    name: 'Cancellation Feedback',
    type: 'cancellation',
    status: 'draft',
    questionCount: 5,
    version: 1,
    lastPublishedIso: null,
    usage: [],
  },
  {
    id: 'tpl-post-stay-v3',
    organizationId: 'sun-intl',
    name: 'Group Post-Stay 2024',
    type: 'post-stay',
    status: 'retired',
    questionCount: 22,
    version: 3,
    lastPublishedIso: '2024-09-01T09:00:00.000Z',
    usage: usage(2, 1),
  },
];
